import script from "./UserCard.vue?vue&type=script&setup=true&lang=js"
export * from "./UserCard.vue?vue&type=script&setup=true&lang=js"

import "./UserCard.vue?vue&type=style&index=0&id=bba65ae8&lang=css"

const __exports__ = script;

export default __exports__